const toggleEventsNav = {
	el: {
		html: document.documentElement,
		body: document.querySelector('body'),
		header: document.querySelector('.header'),
		hamburger: document.querySelector('.js-toggle-hamburger'),
		navLink: document.querySelectorAll('.js-nav-link'),
		mainWrapper: document.querySelector('main')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 75em)')
	},

	fxWatchScrollOnHeaderForRemoveTransparency() {
		if (this.el.header.classList.contains('js-header-transparent')) {
			// when page is scrolled and value is bigger than 1, we remove transparent class 
			if (this.el.html.scrollTop > 1) {
				this.el.header.classList.remove('transparent')
				this.el.mainWrapper.style.paddingTop = 0
			}
			else {
				this.el.header.classList.add('transparent')
			}
		}
		else {
			return
		}
	},

	fxToggleNavLinkActive(el) {
		// remove visited class in all links
		this.el.navLink.forEach(el => el.classList.remove('visited'))

		// add visited class on current clicked link
		el.currentTarget.classList.add('visited')

		// Check if header is open, if yes close it after few seconds
		if (this.el.header.classList.contains('header--open')) {
			setTimeout(() => {
				this.el.header.classList.remove('header--open')
				this.el.body.classList.remove('no-scroll-hidden')
			}, 500)
		}
	},

	fxToggleHamburger(el) {
		// Toggle classes for open and close menu
		this.el.body.classList.toggle('no-scroll-hidden')
		el.classList.toggle('header--open')

		// if user is in homepage and page scroll is equal 0, than we remove transparent class
		if (this.el.header.classList.contains('transparent')) {
			this.el.header.classList.remove('transparent')
		}
	},

	fxWatchResizeForScrollHidden() {
		// Condition that make sure when user is resizing the screen the page will not be locked with scroll hidden
		if (this.vars.extraLargeAndUp.matches && this.el.header.classList.contains('header--open')) {
			this.el.header.classList.remove('header--open')
			this.el.body.classList.remove('no-scroll-hidden')
		}
	},

	events() {
		// click event for open menu
		this.el.hamburger.addEventListener('click', () => this.fxToggleHamburger(this.el.header))

		// click event for links on menu
		this.el.navLink.forEach(el => el.addEventListener('click', e => this.fxToggleNavLinkActive(e)))

		// call this function when load page in order to start header transparent - only Homepage is used
		this.fxWatchScrollOnHeaderForRemoveTransparency()

		// scroll for change transparency on header - only Homepage is used
		window.addEventListener('scroll', () => this.fxWatchScrollOnHeaderForRemoveTransparency())

		// resize event for window
		window.addEventListener('resize', () => this.fxWatchResizeForScrollHidden())
	},

	init() {
		this.events()
	}
}

toggleEventsNav.init()